import { render } from "./ActivationDataSyntaxSelectBox.vue?vue&type=template&id=34e0f63a"
import script from "./ActivationDataSyntaxSelectBox.vue?vue&type=script&lang=ts"
export * from "./ActivationDataSyntaxSelectBox.vue?vue&type=script&lang=ts"
script.render = render

export default script